class GiftBox extends HTMLElement {
  constructor() {
    super();
    this.giftBoxVariantId = this.dataset.giftBoxVariantId;
    this.checkbox = this.querySelector('#enable_gift_box');
    this.toggleButtons = document.querySelectorAll('[toggle-dialog]');
    this.error = this.querySelector('#error');

    this.handleCheckboxChangeHandler = window.debounce(this.handleCheckboxChange.bind(this), 500);
    this.toggleDialogHandler = this.toggleDialog.bind(this);
    this.closeDialogHandler = this.closeDialog.bind(this);
  }

  connectedCallback() {
    if (!this.giftBoxVariantId) {
      this.remove();
      console.error('Gift Boxes: Missing data-gift-box-variant-id attribute');
      return;
    }
    this.initModal();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  initModal() {
    const modalWrapper = document.querySelector('gift-box-modal-wrapper');
    const dialog = this.querySelector('.gift-box__dialog');
    if (dialog) {
      modalWrapper.innerHTML = '';
      modalWrapper.append(dialog);
    }
  }

  bindEvents() {
    this.checkbox.addEventListener('change', this.handleCheckboxChangeHandler);
    this.toggleButtons.forEach((button) => button.addEventListener('click', this.toggleDialogHandler));
    window.addEventListener('cartClosed', this.closeDialogHandler);
  }

  unbindEvents() {
    this.checkbox.removeEventListener('change', this.handleCheckboxChangeHandler);
    this.toggleButtons.forEach((button) => button.removeEventListener('click', this.toggleDialogHandler));
    window.removeEventListener('cartClosed', this.closeDialogHandler);
  }

  handleCheckboxChange(ev) {
    this.error.classList.add('hidden');
    const targetInput = ev.target;
    targetInput.checked ? window.GiftBoxService.addGiftBox() : window.GiftBoxService.removeGiftBox();
  }

  toggleDialog(ev) {
    ev.preventDefault();
    const dialog = document.querySelector('gift-box-modal-wrapper .gift-box__dialog');
    if (dialog.hasAttribute('open')) {
      dialog.removeAttribute('open');
      setTimeout(() => dialog.classList.add('!hidden'), 700);
    } else {
      dialog.classList.remove('!hidden');
      setTimeout(() => dialog.setAttribute('open', ''), 1);
    }
  }

  closeDialog() {
    const dialog = document.querySelector('gift-box-modal-wrapper .gift-box__dialog');
    setTimeout(() => {
      dialog.removeAttribute('open');
      dialog.classList.add('!hidden');
    }, 700);
  }
}

customElements.define('gift-box', GiftBox);
